// extracted by mini-css-extract-plugin
export var decrement = "numeric-input-module--decrement--59ea7";
export var increment = "numeric-input-module--increment--28884";
export var input = "numeric-input-module--input--688f7";
export var wrap = "numeric-input-module--wrap--fdf4f";